import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  try {
    const { data } = await http.post(`/v1/document-type`, payload)
    return data
  } catch (error) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/document-type/add-new/index.js